export default __webpack_public_path__ + "static/media/devices.70b1e421.png";